import { FC } from 'react';
import StepHeader from '../../StepHeader';
import { useAppSelector } from '../../../app/hooks';
import { selectSessionBankLogo, selectSessionBankName } from '../../../app/slices/bank.slice';
import { useFormStepTranslation } from '../useFormStepTranslation';

export const TwoFactorAuthPendingContext: FC = () => {
	const { t } = useFormStepTranslation();
	const bankName = useAppSelector(selectSessionBankName)!;
	const bankLogo = useAppSelector(selectSessionBankLogo) || '';

	return (
		<StepHeader
			title={t('two-factor-authentication')}
			subtitle={t('2fa-authentication-pending-message')}
			bankName={bankName}
			bankLogo={bankLogo}
			withSpinner={true}
		/>
	);
};
